"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_snapshot_1 = require("react-snapshot");
const App_1 = __importDefault(require("./App"));
(0, react_snapshot_1.render)(react_1.default.createElement(App_1.default, null), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js